import { useEffect } from "react"
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react"

import { useBookingStore } from "@/store/booking-store"
import { useRouter } from "@/lib/router-helpers"

export default function BookingSummary({ mode = "booking", appointmentId }: { mode?: "booking" | "reschedule", appointmentId?: string }) {
  const { t } = useTranslation()
  const router = useRouter()
  const {
    selectedBranch,
    selectedService,
    selectedDate,
    selectedSlot,
    lastSlotSelectionTime,
    scheduleEntrySource,
    setBookingState,
  } = useBookingStore()

  // Trigger flow when slot is selected
  useEffect(() => {
    if (selectedSlot && selectedDate && selectedBranch && selectedService) {
      onContinue()
    }
  }, [selectedSlot, selectedDate, selectedBranch, selectedService, lastSlotSelectionTime])

  function onContinue() {
    if (!selectedBranch || !selectedService || !selectedDate || !selectedSlot) {
      return
    }
    // Wizard flow: render next step on same page (no navigation)
    setBookingState({ bookingStep: "mode" })
  }

  function handleBack() {
    if (scheduleEntrySource === "map" && selectedBranch) {
      setBookingState({
        bookingStep: "service",
        selectedService: null,
        selectedSlot: null,
        selectedDate: null,
        scheduleEntrySource: undefined,
      })
      router.push("/map", { state: { selectedBranch: { id: selectedBranch.id, name: selectedBranch.name, subtitle: selectedBranch.subtitle ?? "" } } })
    } else {
      setBookingState({
        bookingStep: "service",
        selectedService: null,
        selectedSlot: null,
        selectedDate: null,
      })
    }
  }

  return (
    <>
      <div className="flex items-center justify-between mt-12 pt-6 border-t border-gray-100">
        <button
          onClick={handleBack}
          className="group px-8 h-12 flex items-center gap-2 rounded-full border border-gray-200 bg-white text-gray-900 text-sm font-semibold hover:border-pink-500 hover:text-pink-600 transition-all duration-300 shadow-sm hover:shadow-md active:scale-95"
        >
          <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-1" />
          {t("back")}
        </button>
      </div>
    </>
  );
}